import React from 'react';
import PPMobileCardView from '../../../components/PPMobileCardView';

const Mobile = ({data,onDelete,onEdit}) => {
    const rows = [
        { label: 'Account Number', value: data.bankAccountNumber },
        { label: 'Opening Balance', value: data.openingBalance },
        { label: 'Description', value: data.description, fullWidth: true },
    ];

    const menuItems = [
        { label: 'Edit', onClick: onEdit },
        { label: 'Delete', onClick: onDelete },
    ];

    return (
        <PPMobileCardView
            title={data.name}
            rows={rows}
            menuItems={menuItems}
        />
    );
};

export default Mobile;
